import * as React from 'react';
import { createFileRoute, redirect, useParams } from '@tanstack/react-router';

import { useCarrier } from '&/features/settings/carriers/hooks';
import DriversPage from '&/features/settings/drivers/pages/drivers-page';
import { useMasterContext } from '&/master';

export const Route = createFileRoute('/_authenticated/settings_/carriers/$carrierId/drivers')({
  beforeLoad: ({ context, params }): void => {
    if (
      context.permissions.isReady &&
      !context.permissions.hasAnyPermission(['carriers:manage', 'carriers:access-read-only'])
    ) {
      throw redirect({ params: { carrierId: params.carrierId }, to: '/settings/carriers/$carrierId' });
    }
  },
  component: CarrierDriversPage,
});

// Derive the space from the carrier (not the breadcrumb) so the drawer locks to the carrier's own
// space and the list is correctly scoped — the breadcrumb can be stale or wrong for the carrier.
function CarrierDriversPage(): React.JSX.Element {
  const { carrierId } = useParams({ from: '/_authenticated/settings_/carriers/$carrierId/drivers' });
  const { data: carrier } = useCarrier(carrierId);
  const { spaceId: contextSpaceId } = useMasterContext();
  const spaceId = carrier?.spaceId ?? contextSpaceId ?? undefined;
  return <DriversPage carrierId={carrierId} spaceId={spaceId} />;
}
